import { Advertiser, BrandWithProductCategory, SelectedBrand } from 'components/common/types/Deal.types';
import DataListProps from 'lib/DataList/DataList.types';

export const normalize = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const filterDealLookupData = async (qry: string, options: DataListProps[]): Promise<DataListProps[]> => {
  if (!qry) return options;

  return options.filter(({ id, title, subText }) =>
    [id, title, subText].some((field) => field && qry && normalize(field).includes(normalize(qry))),
  );
};

export const getBrandForAdvertiserSelection = (
  selectedAdvertiser: Advertiser | null,
  selectedBrands: BrandWithProductCategory[] | undefined,
  currentBrand: BrandWithProductCategory | SelectedBrand | null,
): BrandWithProductCategory | SelectedBrand | null => {
  if (!selectedAdvertiser) {
    return null;
  }

  if (selectedBrands?.length === 1) {
    return selectedBrands[0];
  }

  const hasSelectedAdvertiserOnCurrentBrand = currentBrand?.advertisers?.some(
    (advertiser) => advertiser.code === selectedAdvertiser.code,
  );

  const hasCurrentBrandOnSelectedAdvertiser = selectedBrands?.some((brand) => brand.code === currentBrand?.code);

  if (currentBrand && (hasSelectedAdvertiserOnCurrentBrand || hasCurrentBrandOnSelectedAdvertiser)) {
    return currentBrand;
  }

  return null;
};

export const getAdvertiserForBrandSelection = (
  selectedBrand: BrandWithProductCategory | null,
  currentAdvertiser: Advertiser | null,
): Advertiser | null => {
  if (!selectedBrand) {
    return null;
  }

  const advertisers = selectedBrand.advertisers ?? [];

  if (advertisers.length === 1) {
    return advertisers[0];
  }

  const hasSelectedBrandOnCurrentAdvertiser = currentAdvertiser?.brands?.some(
    (brand) => brand.code === selectedBrand.code,
  );

  const hasCurrentAdvertiserOnSelectedBrand = advertisers.some(
    (advertiser) => advertiser.code === currentAdvertiser?.code,
  );

  if (currentAdvertiser && (hasCurrentAdvertiserOnSelectedBrand || hasSelectedBrandOnCurrentAdvertiser)) {
    return currentAdvertiser;
  }

  return null;
};
